import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { PageLoading } from '@bumble/app/components/PageLoading';
import { ThirdPartyIntegrationForm } from '@bumble/app/components/ThirdPartyIntegrationForm';
import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

interface EntityExternalApiIntegrationEditProps {
  onSubmit: () => void;
  entityId: string;
}

export const EntityExternalApiIntegrationEdit = ({ onSubmit, entityId }: EntityExternalApiIntegrationEditProps) => {
  const api = useApi();

  const { isLoading, data } = useQuery(
    ['get3rdPartyVendorConfig', entityId],
    api.get3RdpartyVendorConfigApiV1Get3RdpartyVendorConfigGet.bind(null, { entity_id: entityId }),
    { enabled: true, cacheTime: 0 },
  );

  const configureVendorConfig = useMutation(api.configure3RdpartyVendorConfigApiV1Configure3RdpartyVendorConfigPost, {
    onSuccess() {
      toast.success('External API integration saved successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = (vendor: string, config: { key: string; value: string }[]) => {
    configureVendorConfig.mutate({ entity_id: entityId, vendor, config });
  };

  if (isLoading) return <PageLoading content="Loading integration settings..." />;

  return (
    <>
      {configureVendorConfig.isLoading && <PageLoading content="Saving..." />}
      <ThirdPartyIntegrationForm
        vendors={data?.data ?? []}
        submitting={configureVendorConfig.isLoading}
        onSubmit={handleSubmit}
      />
    </>
  );
};
